import { Component, HostListener } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DialogService } from 'primeng/dynamicdialog';
import { DialogeComponent } from '../dialoge/dialoge.component';
import { TimesheetService } from '../Services/timesheet.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
FirstName:any;
storedFirstName:any=[]
LoggedUserName:any
SirName:any
showNavbar = false;
changePassModalData: FormGroup | any;
userID:any
userPass:any
resultData: any=[]; 
sidebarOpen = false;
LoggedInUserEmail : any;
isValidUserForSidebar : boolean = false;

ngOnInit(){
  this.storedFirstName = localStorage.getItem('loginDetails');

 // Check if the value is not null before parsing
 if (this.storedFirstName !== null) {
   this.FirstName = JSON.parse(this.storedFirstName);
   this.LoggedUserName = this.FirstName[0].name;
   this.SirName = this.FirstName[0].LastName;
   this.userID=this.FirstName[0].UserMasterID;
   this.userPass=this.FirstName[0].Password;
   this.LoggedInUserEmail = this.FirstName[0].email;
 }

 
  this.validateUserForSidebar(this.LoggedInUserEmail);
}

constructor(private fb: FormBuilder,
  private dialogService: DialogService,
private timeSheetService : TimesheetService){
  this.changePassModalData =  this.fb.group({  
    UserMasterID:[this.userID], 
    NewPassword: ['',[Validators.required]],
    ConfirmPassword: ['',[Validators.required]]   
  } ); 

}

toggleNavbar() {
  this.showNavbar = !this.showNavbar;
  this.changePassModalData.reset();
  this.changePassModalData.patchValue({
    UserMasterID: this.userID,
  });
  
}

toggleSidebar(): void {
    this.sidebarOpen = !this.sidebarOpen;
  }
 
  closeSidebar(): void {
    this.sidebarOpen = false;
  }
 
  // Close sidebar on Escape key
  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closeSidebar();
  }
  
  clearLocalStorage() {
    localStorage.clear();
  }
  
  validateUserForSidebar(email:any){
    this.timeSheetService.getUserValidity(email).subscribe({
      next: (response) => {
        if(response.Data.IsValid.toLocaleLowerCase()==="Valid".toLocaleLowerCase()){
          this.isValidUserForSidebar = true;
        }
      },
      error: (err) => {
        console.error(err);
      }
    });
  }
}
